import React, { Component } from "react";
import CorteCajaTabla from "./CorteCajaTabla";
import { connect } from "react-redux";
import { getCorteCaja } from './AlumnoAction'
import { withRouter } from 'react-router-dom';

class CorteCajaContainer extends Component {

    componentDidMount() {
        var f = new Date();
        var fechaactual = (f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate());
        
        var idusuario = sessionStorage.getItem('idusuario');
        console.log("----->idusuario:" + idusuario);

        this.props.dispatch(getCorteCaja(idusuario));
    }

    render() {
        return (
            <div>
                <CorteCajaTabla />
            </div>
        );
    }
}

export default connect()(CorteCajaContainer);
